import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';

import { Question, QuestionContext } from './Question';

@Component({
	selector: 'vb-webcast-question-attendee-card',
	templateUrl: './VbWebcastQuestionAttendeeCard.Component.html',
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule,
		ButtonsAngularModule,
		PipesAngularModule,
		VbProfilePictureModule
	],
	styleUrl: './VbWebcastQuestionCard.ng.less'
})
export class VbWebcastQuestionAttendeeCardComponent {
	@Input() public question: Question;
	@Input() public questionContext: QuestionContext;

	public readonly QuestionContextType = QuestionContext;
}
